module.exports = "<p>\r\n  grouped-table works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/common/GroupedTable/grouped-table.component.html
// module id = ./src/app/shared/common/GroupedTable/grouped-table.component.html
// module chunks = main